import { render, staticRenderFns } from "./batchRecharge.vue?vue&type=template&id=350c0650&scoped=true"
import script from "./batchRecharge.vue?vue&type=script&lang=js"
export * from "./batchRecharge.vue?vue&type=script&lang=js"
import style0 from "./batchRecharge.vue?vue&type=style&index=0&id=350c0650&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "350c0650",
  null
  
)

export default component.exports